function cov_1n8q6v0d3l() {
  var path = "/app/src/components/v2/button/button.tsx";
  var hash = "4a6ec3bf59580c77af21295cd901556a3b168f8c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/v2/button/button.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 26,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 22
          },
          end: {
            line: 14,
            column: 23
          }
        },
        loc: {
          start: {
            line: 14,
            column: 77
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4a6ec3bf59580c77af21295cd901556a3b168f8c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1n8q6v0d3l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1n8q6v0d3l();
import cn from 'classnames';
import React from 'react';
import { Typography } from '../typography';
import styles from './styles.css';
cov_1n8q6v0d3l().s[0]++;
export var Button = function Button(_ref) {
  var className = _ref.className,
    children = _ref.children,
    onClick = _ref.onClick,
    testAttr = _ref.testAttr;
  cov_1n8q6v0d3l().f[0]++;
  cov_1n8q6v0d3l().s[1]++;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cn(styles.button, className),
    onClick: onClick,
    "data-test": testAttr
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    bold: true,
    className: styles.buttonText
  }, children));
};